import styled from 'styled-components';
import { Card as AntdCard, Row } from 'antd';

export const Card = styled(AntdCard)`
  border-radius: 0.5rem;
`;

export const CardBody = styled(Row)`
  flex-direction: column;
`;
